module.exports = __webpack_public_path__ + "img/logo_snappy.c4b497f9.png";